import PropTypes from 'prop-types';
import React__default from 'react';
import { SwanPopoverDarkModeProvider } from './popover.context.js';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { PopoverInternal } from './popover-internal.component.js';
import { useDarkModeExtractor } from '../../hooks/use-dark-mode-extractor.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
var propTypes = {
  /**
  * Should it be expanded or not?
  */
  expanded: PropTypes.bool,

  /**
  * Position in which should the popover be shown
  */
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
};
var propKeysToRemove = Object.keys(propTypes);
var Popover = renderWithRef('Popover', propTypes, function (props, ref) {
  useComponentStylesLoaded('Popover', SWAN_STYLE_KEY_MAP.popover);
  var position = props.position,
      expanded = props.expanded,
      children = props.children;
  var popoverRef = React__default.useRef();
  var combinedRef = assignRefs(ref, popoverRef);
  var hasDarkMode = useDarkModeExtractor(popoverRef);
  var classNames = ['swan-popover-container'];
  return /*#__PURE__*/React__default.createElement(SwanPopoverDarkModeProvider, {
    value: {
      hasDarkMode: hasDarkMode
    }
  }, /*#__PURE__*/React__default.createElement(RenderComp, {
    root: "div",
    forwardedRef: combinedRef,
    classNames: classNames,
    props: props,
    propKeysToRemove: propKeysToRemove
  }, /*#__PURE__*/React__default.createElement(PopoverInternal, {
    popoverPlacement: position !== null && position !== void 0 ? position : 'top',
    expanded: expanded !== null && expanded !== void 0 ? expanded : undefined
  }, children)));
});
export { Popover };